import { CustomFieldType, EntityType } from "app/utility/enums";
import { FieldType } from "./field.model";
import { ListItemModel } from "./listItem.model";

export class CustomFieldResultModel
{
    public name: string;
    public type: CustomFieldType;
    public visible: boolean;
    public dropdownOptionsString: string;
    public entityType: EntityType;

    public showInGrid: boolean;
    public propertyName: string;
}

//This allows us to access the getters with the incoming DTO properties
export class CustomFieldDisplayModel extends CustomFieldResultModel
{
    constructor(customFieldResultModel: CustomFieldResultModel)
    {
        super();
        Object.assign(this, customFieldResultModel);
    }

    static fromDto(dto: CustomFieldResultModel): CustomFieldDisplayModel {
        return new CustomFieldDisplayModel(dto);
    }

    get fieldModelType(): FieldType 
    {
        switch (this.type) 
        {
            case CustomFieldType.TextArea:
                return 'longtext';
            case CustomFieldType.TextBox:
                return 'text';
            case CustomFieldType.NumericBox:
                return 'number';
            case CustomFieldType.Dropdown:
                return 'select'
            case CustomFieldType.DateInputBox:
                return 'date';
            default:
                return 'text';
        }
    }

    private _dropdownOptions: ListItemModel[] | null = null;

    get dropdownOptions(): ListItemModel[] 
    {
        if (this._dropdownOptions === null) {
            this._dropdownOptions = this.dropdownOptionsString.split('\r\n').map(x => new ListItemModel(x, x));
        }
        return this._dropdownOptions;
    }
}